import { useState } from 'react';
import { SubTableColumn } from 'src/components/commons/subTable/types';

export const COLUMNS: SubTableColumn[] = [
  {
    title: 'Canned Note',
    headerName: 'Canned Note',
    dataIndex: 'note',
    editable: true,
    dataType: 'string',
    filterable: true,
    hidden: false,
    dataStructure: 'string',
    options: [],
    required: true,
    searchField: 'note',
  },
];

export const useCannedNotesHeaders = () => {
  const [columns, setColumns] = useState(COLUMNS);

  return {
    columns,
    setColumns,
  };
};
